import { useEffect } from 'react';

import { getMyProfile } from '@af-fp/api/sdk.gen';

import { useAuthenticationDispatch } from './authentication-context';
import { useIsAuthenticationStateLoaded } from './selectors';

export const useAuthInit = () => {
  const isAuthenticationStateLoaded = useIsAuthenticationStateLoaded();
  const dispatch = useAuthenticationDispatch();

  useEffect(() => {
    if (isAuthenticationStateLoaded) {
      return;
    }

    const isPossiblyAuthenticated = localStorage.getItem('auth');
    if (!isPossiblyAuthenticated) {
      dispatch({
        type: 'logout',
      });
      return;
    }

    getMyProfile()
      .then((profile) => {
        dispatch({
          type: 'login',
          ...profile,
        });
      })
      .catch(() => {
        dispatch({
          type: 'logout',
        });
      });
  }, [isAuthenticationStateLoaded, dispatch]);
};
